import axios from 'axios'

const actions = {
  signIn({commit}) {
    commit('setUserAuth', { userAuthenticated: true})
  },
  signOut({commit}) {
    commit('setUserAuth', { userAuthenticated: false})
  },
};
export default actions;
